var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LandingEnerfip"}},[_c('Hero',[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")])]),_c('PublicBondIssue'),_c('InvestmentDetails'),_c('HowToInvest')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }